import React, { useEffect, useState } from 'react';
import { useTranslation } from '../utils/i18n-utils';
import { changeLanguage } from '../i18n';
import { 
  Box, 
  Switch, 
  FormControlLabel, 
  styled,
  Typography
} from '@mui/material';

// Styled switch with language-specific colors
const LanguageSwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y="50%" x="50%" dominant-baseline="middle" text-anchor="middle" font-size="80">🇸🇦</text></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
    width: 32,
    height: 32,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y="50%" x="50%" dominant-baseline="middle" text-anchor="middle" font-size="80">🇬🇧</text></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2,
  },
}));

const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [isArabic, setIsArabic] = useState(i18n.language === 'ar');

  // Handle language change
  const handleLanguageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newLanguage = event.target.checked ? 'ar' : 'en';
    setIsArabic(newLanguage === 'ar');
    changeLanguage(newLanguage);
  };

  // Update state if language changes from outside this component
  useEffect(() => {
    setIsArabic(i18n.language === 'ar');
  }, [i18n.language]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
      <FormControlLabel
        control={
          <LanguageSwitch 
            checked={isArabic}
            onChange={handleLanguageChange}
            inputProps={{ 'aria-label': 'language switch' }}
          />
        }
        label={
          <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
            {isArabic ? t('language.arabic') : t('language.english')}
          </Typography>
        }
        labelPlacement="end"
      />
    </Box>
  );
};

export default LanguageSwitcher; 